import { Icon, type IconProps } from './Icon';

/** A lightning bolt — skip, fast-forward. */
export function Bolt(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M13 2L4.5 13.5H11l-1 8.5 8.5-11.5H12z" />
    </Icon>
  );
}
